import { ICause } from '@givebacks/api/core';
import { ClickableOptionsCard } from 'core/Components';

import { useCauseActions } from '../../../../hooks/onboarding/useCauseAction';
import { IntentTextData, NavigationIntents } from '../../../../types/onboarding';
import {
  AccountText,
  CauseActionsText,
  FeesText,
  PurchasesText,
  RewardsActivityText,
  RewardsText,
} from './IntentText';

interface CardRowsProps {
  cause?: ICause;
  intents: NavigationIntents;
  textData: IntentTextData;
}

const CardRows = ({ cause, intents, textData }: CardRowsProps) => {
  const {
    handleGoToAccount,
    handleGoToCause,
    handleGoToFees,
    handleGoToRewards,
    handleGoToPurchases,
    handleGoToRewardsActivity,
  } = useCauseActions(cause);

  return (
    <>
      {cause && (
        <ClickableOptionsCard.Row
          title="Visit the Cause page to"
          subtitle={<CauseActionsText data={textData.causeActions} />}
          onClick={handleGoToCause}
        />
      )}

      {Boolean(cause?.release?.student_fees?.beta) && (
        <ClickableOptionsCard.Row
          title="Visit the Fees page to"
          subtitle={<FeesText />}
          onClick={handleGoToFees}
        />
      )}

      {intents.visitRewards && (
        <ClickableOptionsCard.Row
          title="Visit the Rewards page to"
          subtitle={<RewardsText />}
          onClick={handleGoToRewards}
        />
      )}

      {intents.visitPurchases && (
        <ClickableOptionsCard.Row
          title="Visit the Purchases page to"
          subtitle={<PurchasesText />}
          onClick={handleGoToPurchases}
        />
      )}

      {intents.visitAccount && (
        <ClickableOptionsCard.Row
          title="Visit the Account page to"
          subtitle={<AccountText data={textData.account} />}
          onClick={handleGoToAccount}
        />
      )}

      {intents.visitRewardsActivity && (
        <ClickableOptionsCard.Row
          title="Visit the Rewards Activity page to"
          subtitle={<RewardsActivityText />}
          onClick={handleGoToRewardsActivity}
        />
      )}
    </>
  );
};

export { CardRows };
